import { animate, createTimeline } from 'animejs';

const handAnimation = () => {
  const hand = document.querySelector('.tutorialOverlay .hand');

  const timeline = createTimeline({
    autoplay: false,
    defaults: {
      ease: 'linear',
    },
  })
    .add(
      hand,
      {
        opacity: [0, 1],
      },
      0,
    )
    .add(hand, {
      duration: 1800,
      translateX: [-40, 40],
    })
    .add(
      hand,
      {
        opacity: [1, 0],
      },
      1500,
    );
  //loop animation
  // auto play
  timeline.play();
  setInterval(() => {
    timeline.play();
  }, 1600);
};

const fadeOut = (onComplete) => {
  animate(document.querySelector('.tutorialOverlay'), {
    ease: 'linear',
    opacity: [1, 0],
    duration: 400,
    onComplete: () => {
      if (onComplete) {
        onComplete();
      }
    },
  });
};
export { handAnimation, fadeOut };
